module.exports = __webpack_public_path__ + "static/media/4.00c776b9.svg";